import { Box } from '@mui/material';
import { Loading } from '@carbon/react';
import { BRAND_CONTENT_BG } from '../constants/brandColors';

const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: BRAND_CONTENT_BG,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
    <Loading
      description="Active loading indicator"
      withOverlay={false}
    />
  </Box>
);

export default SlashScreen;
